import { connect } from 'react-redux';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import {
  getKnmDataCreated,
  getKnmErknmPositionsSelectOptions,
  getKnmFormRef,
  getKnmOnSaveButtonClick,
  getKnmStatus,
} from 'KnmPackage/MainModule/selectors/knmSelectors';
import { IKnmPmFormAct } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormAct';
import { KnmActExtract } from 'KnmPackage/KnmPaperlessActModule/KnmActExtract/KnmActExtract';
import { KnmActSignButton } from 'KnmPackage/KnmPaperlessActModule/KnmActSignButton/KnmActSignButton';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { ActTypesEnum } from 'KnmErknmPackage/ErknmActsModule/enums';
import { KnmActGeneral } from 'KnmPackage/KnmPaperlessActModule/KnmActGeneral/KnmActGeneral';
import { KnmActGeneralImpossible } from 'KnmPackage/KnmPaperlessActModule/KnmActGeneralImpossible/KnmActGeneralImpossible';
import { KnmActParticipants } from 'KnmPackage/KnmPaperlessActModule/KnmActParticipants/KnmActParticipants';
import { IKnmErknmFormInspector } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormInspector';
import { IKnmErknmFormExpert } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormExpert';
import { KnmActEvents } from 'KnmPackage/KnmPaperlessActModule/KnmActEvents/KnmActEvents';
import { IKnmPmFormRequirementsNpa } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormRequirementsNpa';
import { IDictionaryKnoOrganizationSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryKnoOrganizationSelectOption';
import { IDictionarySupervisionTypeSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySupervisionTypeSelectOption';
import { KnmActSignInfo } from 'KnmPackage/KnmPaperlessActModule/KnmActSignInfo/KnmActSignInfo';
import { KnmActIntroductions } from 'KnmPackage/KnmPaperlessActModule/KnmActIntroductions/KnmActIntroductions';
import { KnmActRemarks } from 'KnmPackage/KnmPaperlessActModule/KnmActRemarks/KnmActRemarks';
import { KnmActAdditional } from 'KnmPackage/KnmPaperlessActModule/KnmActAdditional/KnmActAdditional';
import { getPmStartDate } from 'KnmPmPackage/MainModule/selectors/knmPmSelectors';

import { PmActSubject } from './components/PmActSubject/PmActSubject';
import { PmActViolations } from './components/PmActViolations/PmActViolations';
import { IKnmStatus } from '../../../../../APIPackage/CatalogsModule/interfaces/IKnmStatus';
import { IKnmErknmFormObject } from '../../../../../KnmErknmPackage/MainModule/interfaces/IKnmErknmFormObject';
import { IKnmFormRiskIndicators } from '../../../../../KnmPackage/MainModule/interfaces/IKnmFormRiskIndicators';
import { isLaterThanAdminSetting } from '../../../../../CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from '../../../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { getAdminFetchSettings } from '../../../../../PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { IAdminSetting } from '../../../../../APIPackage/AdminModule/interfaces/IAdminSetting';
import { IDictionaryPositionSelectOption } from '../../../../../CorePackage/DictionariesModule/interfaces/IDictionaryPositionSelectOption';
import { IDictionaryParticipantPositionSelectOption } from '../../../../../CorePackage/DictionariesModule/interfaces/IDictionaryParticipantPositionSelectOption';
import { getLawInterface } from '../../../../../CorePackage/MainModule/reducers/coreReducer';
import { LawInterfacesEnum } from '../../../../../CorePackage/MainModule/enums/LawInterfacesEnum';

interface IPmPaperlessActProps {
  experts?: IKnmErknmFormExpert[];
  inspectorsErknm: IKnmErknmFormInspector[] | undefined;
  isDisabledByDirty?: boolean;
  isDisabledField: boolean;
  isWatchOnly: boolean;
  knoOrganization: IDictionaryKnoOrganizationSelectOption | undefined;
  name: string;
  objectsPm?: IKnmErknmFormObject[];
  requirementsNpa: IKnmPmFormRequirementsNpa[] | undefined;
  riskIndicators?: IKnmFormRiskIndicators[];
  supervisionType: IDictionarySupervisionTypeSelectOption | undefined;
  value: IKnmPmFormAct;
}

interface IPmPaperlessActStoreProps {
  created: string | null | undefined;
  formRef: IKnmFormRef | undefined;
  isErp: boolean;
  knmStatus: IKnmStatus | undefined;
  onSaveButtonClick: (() => void) | undefined;
  positionsSelectOptions: IDictionaryPositionSelectOption[] | IDictionaryParticipantPositionSelectOption[] | undefined;
  settings: IAdminSetting[] | undefined;
  startDate: string | undefined;
}

const PmPaperlessActWithoutStore = ({
  experts,
  inspectorsErknm,
  isDisabledByDirty = false,
  isDisabledField,
  isWatchOnly,
  knoOrganization,
  name,
  objectsPm,
  requirementsNpa,
  riskIndicators,
  supervisionType,
  value,
  created,
  formRef,
  isErp,
  knmStatus,
  onSaveButtonClick,
  settings,
  startDate,
  positionsSelectOptions,
}: IPmPaperlessActProps & IPmPaperlessActStoreProps) => {
  const { typeAct } = value;

  if (!typeAct) return null;

  const isUseSigners = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.ADD_NEW_SIGNER_199_4_1_6_STARTS_FROM,
  );

  const isDisabled = isDisabledField || isDisabledByDirty || !!value.document;

  return (
    <>
      <KnmActExtract extract={value.document} />
      {typeAct.id === ActTypesEnum.PM_PROF_ACT ? (
        <KnmActGeneral
          isPm
          name={name}
          isDisabledField={isDisabled}
          prefixId={name}
          startDate={startDate}
          extractVersion={value.extractVersion}
          signActDateTime={value.signActDateTime}
        />
      ) : (
        <KnmActGeneralImpossible
          isPm
          name={name}
          isDisabledField={isDisabled}
          value={value}
          prefixId={name}
          formRef={formRef}
        />
      )}
      {typeAct.id === ActTypesEnum.PM_PROF_ACT && (
        <>
          <PmActSubject id={name} name={name} value={value} />
          <KnmActParticipants
            id={name}
            inspectorsErknm={inspectorsErknm}
            isDisabledField={isDisabled}
            name={name}
            expertsErknm={experts}
            involvedExperts={value.involvedExperts}
            formRef={formRef}
            isPm
          />
          <KnmActEvents
            id={name}
            name={name}
            isDisabledField={isDisabled}
            formRef={formRef}
            isPm
            isPaperless={value.paperless}
            value={value}
            knmStatus={knmStatus}
          />
          <PmActViolations
            id={name}
            isWatchOnly={isWatchOnly}
            name={name}
            value={value}
            isDisabledField={isDisabledField || !!value.document}
            isDisabledByDirty={isDisabledByDirty}
            formRef={formRef}
            requirementsNpa={requirementsNpa}
            knoOrganization={knoOrganization}
            supervisionType={supervisionType}
            objectsPm={objectsPm}
            riskIndicators={riskIndicators}
          />
        </>
      )}
      <KnmActSignInfo
        formRef={formRef}
        isPm
        value={value}
        id={name}
        isDisabledField={isDisabled}
        isErp={isErp}
        name={name}
        inspectors={inspectorsErknm}
        isUseSigners={isUseSigners}
        positionsSelectOptions={positionsSelectOptions}
      />
      {value.document && (
        <>
          <KnmActIntroductions isPm id={name} name={name} formRef={formRef} isDisabledByDirty={isDisabledByDirty} />
          {typeAct.id === ActTypesEnum.PM_PROF_ACT && (
            <>
              <KnmActRemarks
                isPm
                id={name}
                name={name}
                formRef={formRef}
                isDisabledByDirty={isDisabledByDirty}
                holdingDateTime={value.holdingDateTime}
              />
              {value.fileInvalidate && <KnmActAdditional name={name} isPm attachment={value.fileInvalidate} />}
            </>
          )}
        </>
      )}
      <KnmActSignButton value={value} formRef={formRef} onSaveButtonClick={onSaveButtonClick} isPm name={name} />
    </>
  );
};

const mapStateToProps = (state: IRootState): IPmPaperlessActStoreProps => ({
  created: getKnmDataCreated(state),
  formRef: getKnmFormRef(state),
  isErp: getLawInterface(state) !== LawInterfacesEnum.FZ_248,
  knmStatus: getKnmStatus(state),
  onSaveButtonClick: getKnmOnSaveButtonClick(state),
  positionsSelectOptions: getKnmErknmPositionsSelectOptions(state),
  settings: getAdminFetchSettings(state),
  startDate: getPmStartDate(state),
});

export const PmPaperlessAct = connect(mapStateToProps)(PmPaperlessActWithoutStore);
